function a(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var f = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var i = {}.hasOwnProperty;
    function s() {
      for (var t = "", r = 0; r < arguments.length; r++) {
        var e = arguments[r];
        e && (t = o(t, u(e)));
      }
      return t;
    }
    function u(t) {
      if (typeof t == "string" || typeof t == "number")
        return t;
      if (typeof t != "object")
        return "";
      if (Array.isArray(t))
        return s.apply(null, t);
      if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]"))
        return t.toString();
      var r = "";
      for (var e in t)
        i.call(t, e) && t[e] && (r = o(r, e));
      return r;
    }
    function o(t, r) {
      return r ? t ? t + " " + r : t + r : t;
    }
    n.exports ? (s.default = s, n.exports = s) : window.classNames = s;
  })();
})(f);
var c = f.exports;
const p = /* @__PURE__ */ a(c);
export {
  p as c,
  a as g
};
//# sourceMappingURL=index.bddf5ebb.js.map
